import BCE from './core/BCE.js';
import i18n from './utils/i18n.js';

// Import modules
import slider from './modules/slider/index.js';
import productfinder from './modules/productfinder/index.js';
import eventTeaser from './modules/event-teaser/index.js';
import serviceOverview from './modules/service-overview/index.js';
import serviceTableMaintenance from './modules/service-table-maintenance/index.js';
import serviceMaintenanceSteps from './modules/service-maintenance-steps/index.js';
import eventTicker from './modules/event-ticker/index.js';
import solutions from './modules/solutions/index.js';
import stickyContact from './modules/sticky-contact/index.js';
import accordion from './modules/accordion/index.js';
import headerVideo from './modules/header-video/index.js';
import grid from './modules/grid/index.js';
import components from './modules/components/index.js';
import table from './modules/table/index.js';
import toc from './modules/toc/index.js';
import contentLimiter from './modules/content-limiter/index.js';
import urlParams from './modules/url-params/index.js';
import formTracking from './modules/form-tracking/index.js';
import brancheFull from './modules/branche-full/index.js';
import productOverview from './modules/product-overview/index.js';
import anchorScroll from './modules/anchor-scroll/index.js';
import hotspotImage from './modules/hotspot-image/index.js';
import adminPanel from './modules/admin-panel/index.js';

// Register modules
BCE.register('slider', slider);
BCE.register('productfinder', productfinder);
BCE.register('event-teaser', eventTeaser);
BCE.register('service-overview', serviceOverview);
BCE.register('service-table-maintenance', serviceTableMaintenance);
BCE.register('service-maintenance-steps', serviceMaintenanceSteps);
BCE.register('event-ticker', eventTicker);
BCE.register('solutions', solutions);
BCE.register('sticky-contact', stickyContact);
BCE.register('accordion', accordion);
BCE.register('header-video', headerVideo);
BCE.register('grid', grid);
BCE.register('components', components);
BCE.register('table', table);
// Table of contents
BCE.register('toc', toc);
// Content limiter
BCE.register('content-limiter', contentLimiter);
// URL params form prefiller
BCE.register('url-params', urlParams);
// Product inquiry form tracking (dataLayer + client_lead_id)
BCE.register('form-tracking', formTracking);
// Branchenfinder rebuild — flip-card grid (JSON-driven or transforms the legacy slider)
BCE.register('branche-full', brancheFull);
// Product overview — sectioned card grid + mobile accordion (translatable JSON)
BCE.register('product-overview', productOverview);
// Hotspot image — numbered hotspots with popovers; component is lazy-loaded as its own chunk
BCE.register('hotspot-image', hotspotImage);
// Register table sub-types for specific class detection
BCE.register('table-specs', table);
BCE.register('techdata-table', table); // Legacy support
// Register service-overview under specific class names for BCE auto-detection
BCE.register('service-slider', serviceOverview);
BCE.register('service-grid', serviceOverview);
// Note: Only single solutions layout now supported (sidebar with responsive accordion)

// Make BCE and i18n globally available BEFORE initialization
if (typeof window !== 'undefined') {
    window.BCE = BCE;
    window.BCE.i18n = i18n; // Make i18n available as BCE.i18n
}

// Auto-initialize when DOM is ready
BCE.ready(() => {
    BCE.init();
    // Global module — the inquiry modal is injected dynamically, so there is
    // no bce_ container class to scan for. Initialize explicitly.
    formTracking.init();
    // Global module — class-based anchor scrolling (#class -> .class)
    anchorScroll.init();
    // Global module — editor panel for logged-in TYPO3 backend users (lazy chunk)
    adminPanel.init();
});

export default BCE;
